import React, { useEffect, useRef, useState } from 'react'
import { auth } from '../firebase/firebase'
import { signOut } from 'firebase/auth'

export default function Header({ user, onGoLogin, onGoProfile, onGoSettings, onGoMarketplace }) {
  const [open, setOpen] = useState(false)
  const userRef = useRef(null)
  const menuRef = useRef(null)

  useEffect(() => {
    const onClickOutside = (e) => {
      if (
        open &&
        userRef.current &&
        !userRef.current.contains(e.target) &&
        menuRef.current &&
        !menuRef.current.contains(e.target)
      ) {
        setOpen(false)
      }
    }
    document.addEventListener('click', onClickOutside)
    return () => document.removeEventListener('click', onClickOutside)
  }, [open])

  return (
    <header>
      <div className="container">
        <div className="header-content">
          <a href="#" className="logo" onClick={(e)=>e.preventDefault()}>
            <i className="fas fa-file-contract"></i>
            <span>Doc2Form</span>
          </a>

          <div className="header-actions">
            <div className="header-action-btn" title="Aide"><i className="fas fa-question-circle"></i></div>
            <div
              className="header-action-btn"
              title="Marketplace"
              onClick={() => onGoMarketplace && onGoMarketplace()}
            >
              <i className="fas fa-store"></i>
            </div>
            {user && (
              <div className="header-action-btn" title="Notifications">
                <i className="fas fa-bell"></i><span className="notification-badge">3</span>
              </div>
            )}

            {user ? (
              <div className="user-menu" ref={userRef} onClick={(e)=>{e.stopPropagation(); setOpen((v)=>!v)}} role="button" aria-haspopup="true" aria-expanded={open}>
                <div className="user-avatar">{(user.displayName?.[0]||user.email?.[0]||'U').toUpperCase()}</div>
                <div className="user-info">
                  <div className="user-name">{user.displayName || user.email}</div>
                  <div className="user-role">Utilisateur</div>
                </div>
                <i className="fas fa-chevron-down"></i>
                <div className={`dropdown-menu ${open ? 'show' : ''}`} ref={menuRef}>
                  <a
                    href="#"
                    className="dropdown-item"
                    onClick={(e) => {
                      e.preventDefault()
                      setOpen(false)
                      if (onGoProfile) onGoProfile()
                    }}
                  ><i className="fas fa-user"></i><span>Profil</span></a>
                  <a
                    href="#"
                    className="dropdown-item"
                    onClick={(e) => {
                      e.preventDefault()
                      setOpen(false)
                      if (onGoSettings) onGoSettings()
                    }}
                  ><i className="fas fa-cog"></i><span>Paramètres</span></a>
                  <a href="#" className="dropdown-item" onClick={async (e)=>{ e.preventDefault(); setOpen(false); await signOut(auth) }}><i className="fas fa-sign-out-alt"></i><span>Déconnexion</span></a>
                </div>
              </div>
            ) : (
              <button className="btn btn-primary" onClick={onGoLogin}>Connexion</button>
            )}            
          </div>
        </div>
      </div>
    </header>
  )
}
